import { Directive, ElementRef, HostListener, HostBinding, Optional, Self, Renderer2 } from '@angular/core';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';

@Directive({
  selector: 'kendo-multiselect, [kendoMultiSelect]',
  standalone: false
})
export class MultiSelectDropdownDirective {
  constructor(
    @Optional() @Self() private multiSelect: MultiSelectComponent,
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  @HostBinding('class.k-popup-open')
  get isPopupOpen(): boolean {
    return this.multiSelect?.isOpen ?? false;
  }

  @HostListener('click', ['$event'])
  onHostClick(event: MouseEvent): void {
    if (!this.multiSelect || this.multiSelect.disabled || this.multiSelect.readonly) {
      return;
    }

    const target = event.target as HTMLElement;

    // Do not toggle popup if clicking a chip remove action or clear button
    if (target.closest('.k-chip-remove-action, .k-clear-value, .k-chip-action, .k-i-close, .k-svg-i-x')) {
      return;
    }

    // If clicking directly in an input while popup is already open, keep it open for typing/navigation
    if (target.tagName?.toLowerCase() === 'input' && this.multiSelect.isOpen) {
      return;
    }

    // Toggle the popup open / close state
    const nextState = !this.multiSelect.isOpen;
    this.multiSelect.toggle(nextState);

    if (nextState) {
      this.multiSelect.focus();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.multiSelect || !this.multiSelect.isOpen) {
      return;
    }

    const target = event.target as HTMLElement;
    const hostElement = this.el.nativeElement;

    // If the click is inside the host multiselect component, ignore
    if (hostElement.contains(target)) {
      return;
    }

    // If the click is inside the popup list / animation container, ignore
    const popupElement = this.multiSelect.popupRef?.popupElement;
    if (popupElement && popupElement.contains(target)) {
      return;
    }

    // Check generic Kendo popup container in body
    if (target.closest('.k-animation-container, .k-popup')) {
      return;
    }

    // Clicked outside both host and popup -> close popup
    this.multiSelect.toggle(false);
  }
}

